import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@material-ui/core';
import CloudUpload from '@material-ui/icons/CloudUpload';
import styled from 'styled-components';
import useUserRole from '../../hooks/useUserRole';
import PDF from './PDFCreation/Pdf';
import { base64ToFile, mergePDFs } from '../../Components/InvoiceTool/InvoiceUtil';

const DesktopAddReport = ({
  initialValues,
  isInspectionCompleted,
  getValues,
  cameFromSearch,
  isReadOnly,
  setErrorReport,
  setInspectionReport,
  selectedStatusValue,
  watch,
}) => {
  const { isInspector } = useUserRole();
  const ref = useRef<HTMLInputElement>();
  const [attachFile, setAttachFile] = useState<string>();

  const onUploadExtra = () => {
    ref.current.click();
  };

  const onAttachmentAdded = e => {
    const file = e.target.files[0]; // Get the selected file

    if (file) {
      const reader = new FileReader();
      // When the file is loaded, convert it to Base64
      reader.onloadend = async () => {
        const _attachFile = reader.result.split(',')[1]; // Extract Base64 part
        setAttachFile(_attachFile);
      };
      // Read the file as a Data URL (Base64)
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    const merge = async arr => {
      const result = await mergePDFs(arr);
      const file = base64ToFile(result, initialValues.visibleFilename);
      setInspectionReport(file);
    };

    if (attachFile) {
      const base64Arr: string[] = [initialValues.reportBase64, attachFile];
      merge(base64Arr);
    }
  }, [attachFile]);
  return (
    <Wrapper>
      {isInspector && (
        <PDF
          watch={watch}
          getValues={getValues}
          initialValues={initialValues}
          setInspectionReport={setInspectionReport}
          selectedStatusValue={selectedStatusValue}
        />
      )}
      {!isInspector && (
        <ButtonWrapper>
          <Button
            style={{
              margin: 0,
              borderRadius: '6px',
            }}
            disabled={isInspectionCompleted || cameFromSearch || isReadOnly}
            variant="contained"
            component="label"
            color="primary"
          >
            Add Inspection Report
            <input
              hidden
              name="inspectionReport"
              type="file"
              onChange={e => {
                setErrorReport('');
                setInspectionReport(e.target.files[0]);
              }}
              disabled={isInspectionCompleted || isReadOnly}
              accept="application/pdf,application/msword,
  application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />
          </Button>
          <div title="Use this button to upload any extra documentation to include in the report.">
            {initialValues.report && (
              <div onClick={onUploadExtra}>
                <CloudUpload />
                <input type="file" ref={ref} name="attachments" hidden onChange={onAttachmentAdded} />
              </div>
            )}
          </div>
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};

export default DesktopAddReport;
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 5px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  svg {
    position: relative;
    top: 5px;
    color: var(--primary);
    cursor: pointer;
    &:hover{
      scale: 1.1;
    }
  }
`;
